/**
 * i18n Configuration
 * 國際化配置
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files directly from src
import en from './locales/en.json';
import zhYue from './locales/zh-yue.json';

// Get initial language from localStorage
const savedLanguage = localStorage.getItem('language') || 'en';

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-yue'],
    debug: false,
    
    ns: ['translation'],
    defaultNS: 'translation',
    
    keySeparator: '.',
    nsSeparator: ':',
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: false,
    },
  });

// Add resource bundles AFTER initialization
i18n.addResourceBundle('en', 'translation', en, true, true);
i18n.addResourceBundle('zh-yue', 'translation', zhYue, true, true);

// Set language again to make sure it's applied
i18n.changeLanguage(savedLanguage);

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
